import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HeroSection from "../components/HeroSection";
// NewsMarquee is used indirectly through the marquee wrapper
import RecentNews from "../components/RecentNews";
import { getPlayerData, getGalleryData } from "../api/dataSource";

export default function Home() {
  const navigate = useNavigate();
  // Removed unused news state
  const [recentPlayers, setRecentPlayers] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  
  // Later replace this with API value
  const aboutImage = null; // or "" or undefined
  
  // Helper function to get correct image extension for gallery
  const getGalleryImageExtension = (id) => {
    const extensions = {
      1: '.webp', 2: '.webp', 3: '.webp', 4: '.webp',
      5: '.webp', 6: '.jpeg', 7: '.jpg', 8: '.webp'
    };
    return extensions[id] || '.jpg';
  };

  const navigateToPage = (path) => {
    navigate(path);
    // Scroll to top after navigation
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  useEffect(() => {
    const fetchAllData = async () => {
      const players = await getPlayerData();
      const gallery = await getGalleryData();
      setRecentPlayers(players.slice(0, 4)); // Last 4 players
      setGalleryImages(gallery);
    };
    fetchAllData();
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <HeroSection />

      {/* Recent News Carousel */}
      <div id="recent-news-section" className="py-0">
        <div className="max mx-auto">
          <RecentNews />
        </div>
      </div>
<section className="py-12 sm:py-16 bg-gradient-to-b from-gray-50 to-white">
  <div className="max-w-6xl mx-auto px-4 sm:px-6">

    {/* SECTION HEADING */}
    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-blue-700 mb-8 sm:mb-12 text-center font-poppins">
      About RDCA
    </h2>

    {/* CONTENT */}
    <div className="grid grid-cols-1 md:grid-cols-12 gap-6 sm:gap-12 items-center">

      {/* LEFT – TEXT */}
      <div className="md:col-span-8 bg-white border border-gray-200 rounded-2xl shadow-xl p-6 sm:p-10 relative min-h-[300px] sm:min-h-[350px] flex flex-col justify-between">

        {/* Accent bar */}
        <div className="absolute top-0 left-0 w-16 sm:w-20 h-1 bg-blue-600 rounded-tl-2xl"></div>

        <div>
          <p className="text-gray-700 leading-relaxed text-base sm:text-lg mb-4">
            Ranipet District Chess Academy is committed to developing chess talent
            at the grassroots level. We organize tournaments, structured training
            programs, and promote chess education throughout the district.
          </p>

          <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
            Founded with the vision to make Ranipet a hub of chess excellence,
            RDCA has produced several state and national-level players and
            continues to nurture young minds through chess.
          </p>
        </div>

        <button
          onClick={() => navigateToPage("/about")}
          className="mt-6 sm:mt-8 self-start inline-flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-blue-900 font-semibold px-6 sm:px-8 py-2 sm:py-3 rounded-lg transition-all shadow-md text-sm sm:text-base"
        >
          More →
        </button>
      </div>

      {/* RIGHT – IMAGE */}
      <div className="md:col-span-4">
        <div className="h-64 sm:h-80 rounded-2xl overflow-hidden shadow-xl border border-gray-200">
          <img
            src={aboutImage || "/images/chessabout.webp"}
            alt="About RDCA"
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
            onError={(e) => {
              e.currentTarget.src = "/images/chessabout.webp";
            }}
          />
        </div>
      </div>

    </div>
  </div>
</section>



      {/* Recently Registered Players */}
      <section className="pt-12 sm:pt-12 pb-12 sm:pb-16 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          {/* Improved Heading Layout */}
          <div className="relative mb-8 sm:mb-16 text-center sm:text-left">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center text-blue-700 font-poppins tracking-wide">
              Recently Registered Players
            </h2>

            <p className="text-center text-gray-500 mt-2 sm:mt-3 text-base sm:text-lg">
              Welcome our newest chess talents
            </p>

            <button
              onClick={() => navigateToPage("/players")}
              className="hidden sm:block absolute right-0 top-1 text-blue-600 font-semibold hover:underline"
            >
              See All →
            </button>
            
            {/* Mobile See All Button */}
            <div className="sm:hidden mt-4">
              <button
                onClick={() => navigateToPage("/players")}
                className="text-blue-600 font-semibold hover:underline inline-flex items-center"
              >
                See All →
              </button>
            </div>
          </div>

          {/* Premium Player Cards - Responsive Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
            {recentPlayers.map(player => (
              <div
                key={player.id}
                className="group bg-white rounded-2xl sm:rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden"
              >
                <div className="relative overflow-hidden ">
                  <img
                    src={player.photo || `/images/p${player.id}.jpg`}
                    alt={player.name}
                    className="w-full h-80 sm:h-72 md:h-80 object-cover object-[50%_20%] group-hover:scale-110 transition-transform duration-700"
                    onError={(e) => {
                      // Try jpg first, then png, then webp
                      const extensions = ['.jpg', '.png', '.webp'];
                      let tried = 0;
                      
                      const tryNextExtension = () => {
                        if (tried < extensions.length) {
                          e.currentTarget.src = `/images/p${player.id}${extensions[tried]}`;
                          tried++;
                        }
                      };
                      
                      tryNextExtension();
                    }}
                  />

                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

                  {/* New Badge */}
                  <span className="absolute top-3 right-3 sm:top-4 sm:right-4 bg-yellow-400 text-blue-900 text-xs font-bold px-2 py-1 sm:px-3 sm:py-1 rounded-full shadow">
                    New
                  </span>
                </div>

                <div className="p-3 sm:p-4 text-center">
                  <h3 className="text-base sm:text-lg font-bold text-gray-800">
                    {player.name}
                  </h3>

                  <p className="text-xs sm:text-sm text-gray-500 mt-1">
                    RDCA Player
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Preview */}
      <section className="pt-12 sm:pt-16 pb-16 sm:pb-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          {/* Gallery Heading */}
          <div className="relative mb-8 sm:mb-16 text-center sm:text-left">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center text-blue-700 font-poppins">
              Gallery
            </h2>

            <p className="text-center text-gray-500 mt-2 sm:mt-3 text-base sm:text-lg">
              Moments from tournaments & training
            </p>

            <button
              onClick={() => navigateToPage("/gallery")}
              className="hidden sm:block absolute right-0 top-1 text-blue-600 font-semibold hover:underline"
            >
              See All →
            </button>
            
            {/* Mobile See All Button */}
            <div className="sm:hidden mt-4">
              <button
                onClick={() => navigateToPage("/gallery")}
                className="text-blue-600 font-semibold hover:underline inline-flex items-center"
              >
                See All →
              </button>
            </div>
          </div>

          {/* Premium Gallery Cards - Responsive Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
            {galleryImages.slice(0, 8).map((image, index) => (
              <div
                key={image.id}
                className="group relative overflow-hidden rounded-2xl sm:rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500"
              >
                <img
                  src={image.image || `/images/g${((image.id - 1) % 8) + 1}${getGalleryImageExtension(((image.id - 1) % 8) + 1)}`}
                  alt="Gallery"
                  className="w-full h-32 sm:h-40 md:h-56 object-cover object-center group-hover:scale-110 transition-transform duration-700"
                  onError={(e) => {
                    // Try jpg first, then webp, then jpeg
                    const id = ((image.id - 1) % 8) + 1;
                    const extensions = ['.jpg', '.webp', '.jpeg'];
                    let tried = 0;
                    
                    const tryNextExtension = () => {
                      if (tried < extensions.length) {
                        e.currentTarget.src = `/images/g${id}${extensions[tried]}`;
                        tried++;
                      }
                    };
                    
                    tryNextExtension();
                  }}
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition duration-500 flex items-center justify-center">
                  <span className="text-white font-semibold text-sm sm:text-base md:text-lg">
                    View Image
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>



    </div>
  );
}